import React, { Component } from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";

class PublishingBody extends Component {
  handleSingleClick = (e, id) => {
    const { studentIds } = this.props;
    const selectedIndex = studentIds.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(studentIds, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(studentIds.slice(1));
    } else if (selectedIndex === studentIds.length - 1) {
      newSelected = newSelected.concat(studentIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        studentIds.slice(0, selectedIndex),
        studentIds.slice(selectedIndex + 1)
      );
    }
    this.props.handleClick(newSelected);
  };

  render() {
    const { data, index, studentIds } = this.props;
    const attendance = data.marks.map((mark) => mark.status);
    const resultStatus = data.marks.map((mark) => mark.resultStatus);
    return (
      <TableRow key={index}>
        <TableCell align="center">
          {data.publish === false ? (
            <Checkbox
              onClick={(e) => this.handleSingleClick(e, data._id)}
              checked={studentIds.includes(data._id) ? true : false}
            />
          ) : (
            <>Already Published</>
          )}
        </TableCell>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">
          {data.studentId.firstName} {data.studentId.middleName}{" "}
          {data.studentId.lastName}
        </TableCell>
        {data.publish ? (
          <TableCell
            align="center"
            style={{ color: "green", fontWeight: "bold" }}
          >
            Published
          </TableCell>
        ) : (
          <TableCell
            align="center"
            style={{ color: "red", fontWeight: "bold" }}
          >
            Not Published
          </TableCell>
        )}
        {attendance.includes("Absent") ? (
          <TableCell
            align="center"
            style={{ color: "red", fontWeight: "bold" }}
          >
            Absent
          </TableCell>
        ) : (
          <TableCell
            align="center"
            style={{ color: "green", fontWeight: "bold" }}
          >
            Present
          </TableCell>
        )}
        {resultStatus.includes("Fail") ? (
          <TableCell
            align="center"
            style={{ color: "red", fontWeight: "bold" }}
          >
            Fail
          </TableCell>
        ) : (
          <TableCell
            align="center"
            style={{ color: "green", fontWeight: "bold" }}
          >
            Pass
          </TableCell>
        )}
      </TableRow>
    );
  }
}

export default PublishingBody;
